import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../components/loading/loading';
import LogoMahajanga from "../../assets/logomahajanga 1.png";

function LoadingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/menu');
    }, 5000);
    
    return () => clearTimeout(timer); // Nettoyage du timer pour éviter les fuites de mémoire
  }, [navigate]);

  return (
    <div className='bg-[#212122] w-screen h-screen flex items-center justify-center'>
      <div className='flex flex-col'>
        <div className='flex justify-center w-[1000px]'>
          <img src={LogoMahajanga} alt="mahajanga logo" />
        </div>
        <div className='text-white text-5xl flex items-center justify-center mt-10'>
          Bienvenu sur SIGRL
        </div>
        <div className='mt-10 flex justify-center'>
          <Loader />
        </div>
      </div>
    </div>
  );
}

export default LoadingPage;
